{
    "raportakimhedefaylik": {
        "Baslik": "Team Target Monthly Report",
        "Yil": "Year",
        "Ay": "Month",
        "Takim": "Team",
        "Detay": "Performance Details",
        "Urun": "Product / Group",
        "HedefAdet": "Target Quantity",
        "HedefTutar": "Target Amount",
        "GerceklesenAdet": "Realized Quantity",
        "GerceklesenTutar": "Realized Amount",
        "Kullanici": "User",
        "Ara": "Search",
        "Temizle": "Clear"
    }
}
